import { InchesToFeetAndInches } from "../../../utils/functions";

const FORTY_YARD_DASH = "40 yard dash";
const YARDS_PER_MILE = 1760;
const SECONDS_PER_HOUR = 3600;
const FORTY_YARDS = 40;

export function isFortyYardDash(physicalTestName) {
  return (physicalTestName ?? "").trim().toLowerCase() === FORTY_YARD_DASH;
}

export function calculateTopMph(stageValue) {
  const seconds = Number.parseFloat(stageValue);

  if (!Number.isFinite(seconds) || seconds <= 0) {
    return null;
  }

  return (FORTY_YARDS * SECONDS_PER_HOUR) / (YARDS_PER_MILE * seconds);
}

export function formatTopMph(stageValue) {
  const mph = calculateTopMph(stageValue);

  if (mph === null) {
    return null;
  }

  return mph.toFixed(2);
}

export function isFortyYardSplit(stage) {
  return String(stage ?? "").trim() === "40";
}

export function formatDrillValue(result) {
  if (result.physicalTestName === "Med Ball") {
    return InchesToFeetAndInches(result.stageValue);
  }
  if (result.physicalTestName === "Kicker Charting") {
    const parsed = parseInt(result.stageValue, 10);
    return Number.isNaN(parsed) ? result.stageValue : parsed;
  }
  if (result.physicalTestName === "Vertical jump") {
    return formatInches(result.stageValue);
  }
  if (result.physicalTestName === "Broad jump") {
    return formatInches(result.stageValue);
  }
  return result.stageValue;
}

export function formatInches(value) {
  if (value == null || String(value).trim() === "") {
    return null;
  }
  return `${value}"`;
}
